export default __webpack_public_path__ + "static/media/Disposal-empty-state-icon.5951e40e.svg";